import { Customer } from "../customer/shared/customer.model";
import { DealerRep } from "../dealer-rep/shared/dealer-rep.model";
import { Dealer } from "../dealer/shared/dealer.model";
import { Employee } from "../employee/shared/employee.model";
import { BaseUser } from "../user/base-user.model";
import { UnknownUser } from "../user/unknown-user.model";

export class UserAccountUtil {
    public static createUserAcountInstance(userType: string, object: Object): BaseUser {

        if (userType == "customer") {
            return Customer.toCustomer(object);

        } else if (userType == "dealer") {
            return Dealer.toDealer(object);

        } else if (userType == "dealer-rep") {
            return DealerRep.toDealerRep(object);

        } else if (userType == "employee") {
            return Employee.toEmployee(object);

        } else {
            return UnknownUser.toUnknownUser(object);
        }
    }
}